import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.292 8.886a2.91 2.91 0 0 1 2.905 2.916v2.389l.471.244a.75.75 0 0 1-.471 1.395v5.523a1.83 1.83 0 0 1-1.828 1.833H9.631a1.83 1.83 0 0 1-1.828-1.833v-5.521a.75.75 0 0 1-.487-1.387l.487-.268v-2.375a2.91 2.91 0 0 1 2.906-2.916zm1.405 11.129c-.84.295-1.762.45-2.673.463a8.2 8.2 0 0 1-2.722-.407v1.282a.33.33 0 0 0 .328.333h4.738a.33.33 0 0 0 .328-.333v-1.338zm0-4.817c-1.698-.572-3.702-.604-5.395-.025v3.284c.777.356 1.725.536 2.699.521s1.922-.22 2.695-.581zm-3.988-4.812c-.772 0-1.406.63-1.406 1.416v1.801c1.742-.486 3.672-.456 5.395.025v-1.826a1.41 1.41 0 0 0-1.405-1.416z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.268 4.325c4.571-2.466 10.966-2.288 15.454.01l.442.235.065.041a.75.75 0 0 1 .223.98 1 1 0 0 1-.092.126q-.032.047-.071.09l-3.442 3.55a.75.75 0 0 1-1.077-1.044l2.788-2.876c-3.907-1.799-9.23-1.912-13.139-.017l2.78 2.895.05.059a.75.75 0 0 1-1.132.981l-3.458-3.6a.75.75 0 0 1-.209-.534V5.21a.75.75 0 0 1 .303-.587l.064-.042.45-.256z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const FrontViewCameraIcon = ForwardRef;